<div class="page-header">
  <span class="page-header-icon"><i class="fe {{ icon() }}"></i></span>

  <div class="page-header-content">
    @if (pretitle()) {
      <span class="page-header-pretitle">{{ pretitle() }}</span>
    }
    <h1 class="page-header-title">{{ title() }}</h1>
    @if (description()) {
      <p class="page-header-desc">{{ description() }}</p>
    }
  </div>

  <div class="page-header-actions">
    <ng-content select="[actions]" />
  </div>
</div>
